import { action, makeObservable, observable } from "mobx";
import { CachedItem } from "@lib-shared/lib";
import { Key } from "core/constants";
import { BaseStore } from "./base.store";

const oneDayInSeconds = 86400;
const statementsCache = new CachedItem(Key.latestStatements, true, oneDayInSeconds);

class LatestStatementsStore extends BaseStore {
    latestStatement: any | null = null;

    constructor() {
        super();

        this.latestStatement = statementsCache.get();

        makeObservable(this, {
            latestStatement: observable,
            updateLatestStatement: action
        });
    }

    reset() {
        super.reset();
        this.latestStatement = null;
    }

    updateLatestStatement(value: Array<any>) {
        this.latestStatement = value;
        statementsCache.set(value);
    }
}

export default LatestStatementsStore;
